<template>
    <div class="inner-app-root">
        <router-view></router-view>
    </div>
</template>
<script>
import loader from '@/common/loader';
import TypeUtils from '@/common/utils/TypeUtils';
import MessageType from '@/components/common/message-box/MessageType';
import { RouteMapper } from '@/router';
import store from '@/store';

export default {
  name: 'App',
  store,
  methods: {
    attachNetworkErrorHandler() {
      loader.networkErrorHandler = error => {
        const response = error.response();
        let message;
        if (response !== null) {
          message = response.msg || response.errormsg;
        } else {
          this.$alert('网络异常，您可以稍后重试', null, MessageType.FAIL);
          return;
        }
        if (TypeUtils.isString(message)) {
          this.$alert(message, null, MessageType.FAIL);
        } else {
          if (response.status === 503 || response.status === 510) {
            this.$alert('当前体验人数过多，请稍后重试', null, MessageType.FAIL);
          } else if (response.status === 413) {
            this.$alert('请求包体太大，请压缩上传文件大小重试', null, MessageType.FAIL);
          } else {
            this.$alert('网络异常，您可以稍后重试', null, MessageType.FAIL);
          }
        }
      };
    },
    attachRouterListener() {
      let router = this.$router;
      router.afterEach(() => {
        // 将scrollbar复位
        window.scrollTo(0, 0);
        this.$timer.releaseAutoTask();
      });
      router.transfer = (key, params) => {
        let route = RouteMapper[key];
        if (route == null) {
          console.error(`Can not find route by ${key}`);
        }
        router.push({
          path: route.path,
          query: params
        });
      };
    }
  },
  created() {
    this.attachRouterListener();
    this.attachNetworkErrorHandler();
  }
};
</script>
<style lang="less">
@import "./styles/btn.less";
@import "./styles/icon.less";
.inner-app-root {
  height: 100%;
  .el-dialog__headerbtn {
    font-size: 18px;
    font-weight: bold;
    top: 12px;
    right: 12px;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue